import { concat } from '@ember/helper';
import { service } from '@ember/service';
import AppHeaderBanner from './header/banner';
import { PhArrowSquareOut } from 'ember-phosphor-icons';
import Component from '@glimmer/component';
import TioHeaderMenuButton from 'tio-common/components/tio/header/menu-button';
import type SessionContextService from 'tio-employee/services/session-context';
import type SideDrawerService from 'tio-common/services/side-drawer';
import type RoleViewModel from 'tio-data/models/role-view';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import type Owner from '@ember/owner';
import type PartnerService from 'tio-employee/services/partner';
interface AppHeaderSignature {
  Element: HTMLHeadElement;
}
export default class AppHeaderComponent extends Component<AppHeaderSignature> {
  @service declare sessionContext: SessionContextService;
  @service declare sideDrawer: SideDrawerService;
  @service declare partner: PartnerService;
  @tracked currentRole?: RoleViewModel;
  constructor(owner: Owner, args: never) {
    super(owner, args);
    this.currentRole = this.sessionContext.currentRole;
  }
  toggleDrawer = () => {
    this.sideDrawer.toggleDrawer();
  };
  setCurrentRole = (role: RoleViewModel) => {
    this.sessionContext.setCurrentRole(role);
    this.currentRole = role;
  };
  get partnerUrlString() {
    return this.partner.partnerUrlString;
  }
  get partnerName() {
    return this.partner.company?.name || '';
  }
  <template>
    <header class="isolate top-0 tio-bg-surface z-5" ...attributes>
      <div class="tio-row-between px-2">
        {{! template-lint-disable simple-unless }}
        <TioHeaderMenuButton @onClick={{this.toggleDrawer}} class="lg:hidden" />
        <AppHeaderBanner @company={{this.sessionContext.currentRole.company}} />
        {{#if this.partnerUrlString}}
          <div class="flex h-14 header-right text-sm items-end gap-2">
            <div class="flex flex-row items-center text-right gap-2">
              <p>{{t "instride.looking_for_coverage" partner=this.partnerName}}</p>
              <a
                class="underline underline-offset-2 tio-fg-info hover:tio-fg-info-body visited:text-purple-600 tio-row-extra-tight"
                href={{this.partnerUrlString}}
                target="_blank"
                rel="noopener noreferrer"
              >{{concat this.partnerName " " (t "dashboard")}}<PhArrowSquareOut @size={{16}} /></a>
            </div>
          </div>
        {{/if}}
      </div>
    </header>
  </template>
}
